/**
 * @name EmployeeDetail
 * @description Componente común con detalles de un empleado (avatar, nombre, detalle puesto/área/sucursal)
 * @author César Rivera
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Avatar, Typography } from '@styles';

const EmployeeDetail = (props) => {
  const {
    avatar,
    avatarSize,
    employeeName,
    employeeDetail,
    employeeSubDetail,
    hideAvatar,
  } = props;

  return (
    <Styled.FlexBox>
      {!hideAvatar && (
        <Styled.AvatarBox>
          <Avatar
            size={avatarSize ? avatarSize : 'xs'}
            src={avatar ? avatar : 'https://assets.talentry.io/icons/profile/TAL_Avatar.png'}
          >
          </Avatar>
        </Styled.AvatarBox>
      )}
      <Styled.EmployeeBox>
        <Styled.EmployeeName>
          <Typography.Medium>{employeeName}</Typography.Medium>
        </Styled.EmployeeName>
        <Styled.EmployeeDetail>
          <Typography.Small>{employeeDetail}</Typography.Small>
        </Styled.EmployeeDetail>
        <Styled.EmployeeSubDetail>
          <Typography.Medium>
            <Typography.Small>{employeeSubDetail}</Typography.Small>
          </Typography.Medium>
        </Styled.EmployeeSubDetail>
      </Styled.EmployeeBox>
    </Styled.FlexBox>
  );
};

EmployeeDetail.propTypes = {
  // URL de la foto del empleado.
  avatar: PropTypes.string,
  // Tamaño de la foto del empleado.
  avatarSize: PropTypes.oneOf(['xs', 'sm', 'md, lg', 'xl']),
  // Label principal. (Nombre del empleado)
  employeeName: PropTypes.string,
  // Label secundario. (Puesto/Área del empleado)
  employeeDetail: PropTypes.string,
  // Label terciario. (Puesto/Área/Sucurdal del empleado)
  employeeSubDetail: PropTypes.string,
  // Boolean que indica si se oculta el avatar del empleado.
  hideAvatar: PropTypes.bool
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FlexBox = styled.div`
   display: flex;
   flex: 1;
 `;

Styled.AvatarBox = styled.div`
   margin-right: 16px;
   align-self: center;
 `;

Styled.EmployeeBox = styled.div`
   align-self: center;
 `;

Styled.EmployeeName = styled(Typography.Text)`
   line-height: 1.2;
 `;

Styled.EmployeeDetail = styled(Typography.Text)`
   line-height: 1.2;
 `;

Styled.EmployeeSubDetail = styled(Typography.Text)`
   line-height: 1.2;
 `;

export default EmployeeDetail;